import { selectors, verifiers } from '@yola/subscription-manager-js';
import store from 'src/js/store';
import analytics from 'src/js/modules/analytics';
import config from 'src/js/modules/config';
import user from 'src/js/modules/user';
import features from 'src/js/modules/features';
import subscriptions from 'src/js/modules/subscriptions';
import i18n from 'src/js/modules/i18n';
import sites from 'src/js/modules/sites';
import dialogs from 'src/js/modules/dialogs';
import extraPriceTypes from 'src/js/modules/domain-selector/constants/extra-price-types';
import segment from './modules/analytics/segment';
import products from './modules/products';
import featureFlags from './modules/feature-flags';
import googleTagManager from './modules/analytics/google-tag-manager';

/*
  This listener indicates if a webpage is loaded from the cache.
  In this case we should reload the page.
*/
window.addEventListener('pageshow', (event) => event.persisted && window.location.reload());

const initApp = async () => {
  await store.dispatch(config.thunks.fetchConfig());
  analytics.sentry.instance.init(config.selectors.getSentryDSN(store.getState()));
  googleTagManager.init(config.selectors.getGTM(store.getState()));
  user.helpers.configureYousersJS(store);
  subscriptions.helpers.configureSubscriptionsManager(store);

  await store.dispatch(user.thunks.fetchUserData());

  try {
    await Promise.all([
      store.dispatch(user.thunks.fetchUserPreferences()),
      store.dispatch(user.thunks.fetchPartnerData()),
    ]);
  } catch (error) {
    console.error(error);
    return;
  }

  await Promise.all([
    store.dispatch(features.thunks.fetchAvailablePackages()),
    store.dispatch(features.thunks.fetchEcommercePackages()),
  ]);
  await i18n.initializers.initializeI18next();
  dialogs.initializers.registerDialogs();

  await store.dispatch(i18n.thunks.loadTranslations());
  await Promise.all([
    store.dispatch(subscriptions.thunks.fetchSubscriptions()),
    store.dispatch(subscriptions.thunks.fetchCurrentPackage()),
  ]);
  const state = store.getState();
  const hasTrialSubscription = verifiers.hasTrialSubscription(
    selectors.getActiveSubscriptions(state)
  );
  await store.dispatch(
    products.thunks.fetchPrices(hasTrialSubscription ? extraPriceTypes.ANNUAL_TRIAL_PACKAGE : '')
  );
  await store.dispatch(sites.thunks.loadSites());
  segment.trackers.trackAppOpened();

  const featureFlagsManager = featureFlags.serviceClient.get();
  await featureFlagsManager.request(['nn_difm_promo', 'free_trial_upsell', 'freedomain']);
};

export default initApp;
